import { definePreset } from '@primeng/themes';
import Lara from '@primeng/themes/lara';

const MyPreset = definePreset(Lara, {
    semantic: {
        colorScheme: {
            light: {
                primary: {
                    color: '#2a67b1',   // ✅ main color for buttons, links, highlights
                    contrastColor: '#ffffff', // text/icon color on top of primary
                    hoverColor: '#21548f',    // optional (darker shade for hover)
                    activeColor: '#1a3f6c'    // optional (pressed state)
                }
            }
        }
    },
    components: {
        card: {
            colorScheme: {
                light: {
                    root: {
                        background: '#f8f8f9' // optional (card background color)
                    }
                }
            }
        },
        panelmenu: {
            colorScheme: {
                light: {
                    panel: {
                        background: "#0f2643",
                        borderColor: "transparent",
                        color: "white"
                    },
                    item: {
                        color: "#abc7e6",
                        focusBackground: "#153257",
                        focusColor: "#fff"
                    }
                }
            }
        },
        drawer: {
            root: {
                background: "#0f2643",
                borderColor: "#0f2643"
            },
            content: {
                padding: "0px"
            }
        },
        datatable: {
            headerCell: {
                padding: "10px"
            },
            bodyCell: {
                padding: "10px",
                borderColor: "transparent"
            },
        },
        paginator: {
            navButton: {
                selectedBackground: "#2a67b1",
                selectedColor: "#fff",
                borderRadius: "5px",
                width: "32px",
                height: "32px",
            }
        },
        select: {
            option: {
                focusColor: "#fff",
                focusBackground: "#2a67b2",
                color: "#5a6a7f",
                selectedFocusBackground: "#2a67b2",
                selectedFocusColor: "#fff",
                borderRadius: "none",
            },
            root: {
                focusRing: {
                    shadow: "transparent"
                }
            },
            list: {
                padding: "0px"
            }
        },
        multiselect: {
            option: {
                color: "#313144",
                selectedColor: "#313144",
                selectedFocusColor: "#313144"
            },
            root: {
                focusRing: {
                    shadow: "transparent"
                }
            },
            list: {
                padding: "0px"
            }
        },
        inputtext: {
            root: {
                focusRing: {
                    shadow: "transparent"
                }
            }
        },
        panel: {
            header: {
                borderColor: "transparent",
            }
        },
        checkbox: {
            root: {
                width: "1.2em",
                height: "1.2em",
            }
        },
        tooltip: {
            root: {
                padding: "6px 8px",
            }
        }
    }
});

export default MyPreset;    